import { create } from 'zustand';

export interface ProfileTarget {
  id: string;
  name: string;
}

interface ProfileState {
  user: ProfileTarget | null;
  /** The name or avatar that was clicked: the card opens next to it and focus goes back to it. */
  from: HTMLElement | null;
  /** Opens the card; clicking the same person again closes it. */
  toggle(user: ProfileTarget, from: HTMLElement): void;
  hide(): void;
}

/** The profile card opened from a person's name or avatar (rendered once by Shell). */
export const useProfile = create<ProfileState>()((set, get) => ({
  user: null,
  from: null,
  toggle: (user, from) => (get().user?.id === user.id && get().from === from ? set({ user: null, from: null }) : set({ user, from })),
  hide: () => set({ user: null, from: null }),
}));
